/**
 * @generated SignedSource<<8cee34913d2a46aec154dd78bd117173>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DialogButtonTeamsDetail_team$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIconCircle">;
  readonly " $fragmentType": "DialogButtonTeamsDetail_team";
}>;
export type DialogButtonTeamsDetail_team$key = ReadonlyArray<{
  readonly " $data"?: DialogButtonTeamsDetail_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"DialogButtonTeamsDetail_team">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DialogButtonTeamsDetail_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIconCircle"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "535eb98aa2a58a28660226cce9de2fc0";

export default node;
